import { render, staticRenderFns } from "./top-event-referrals-card.vue?vue&type=template&id=2d65ff30&scoped=true&"
import script from "./top-event-referrals-card.vue?vue&type=script&lang=js&"
export * from "./top-event-referrals-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65ff30",
  null
  
)

export default component.exports